import colors from "../../../design/colors";

const styles = {
    container: {
        width: "312px",
        display: "flex",
        flexDirection: "column",
    },
    header: {
        paddingTop: "12px",
        display: "inline-block",
        lineHeight: "auto",
        background: "#f7f7f7",
        textAlign: "center",
        width: "100%",
        paddingBottom: "4px",
    },
    numberNotVerifiedContent: {
        padding: "20px 18px 10px 18px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        borderRadius: "10px 10px 0px 0px",
        overflow: 'hidden',
    },
    pl1: { margin: 0, lineHeight: "22px" },
    pl2: { margin: 0, lineHeight: "20px" },
    actionsContainer: {
        display: "flex",
        justifyContent: "flex-end",
        gap: "12px",
        padding: "12px 18px 18px",
    },
    callingFromLabelContainer: {
        background: "#f7f7f7",
        padding: "0px 18px 12px",
    },
    callingFromLabelContentContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        background: "#fff",
        borderRadius: "4px",
        padding: "8px 12px",
    },
    numberVerifiedContent: {
        padding: "20px 18px 10px 18px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        borderRadius: "0px 0px 6px 6px",
    },
    otpInput: {
        padding: "8px 12px",
        width: "100%",
        height: "36px",
        borderRadius: "4px",
        outline: "none",
        boxSizing: "border-box",
    },
    verifiedNumbersHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "15px 18px",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: colors.tc_gray
    },
    verifiedNumbersContent: {
        padding: "0px 18px 12px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        backgroundColor: colors.tc_gray
    },
    chip: {
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
    },
    chipText: {
        padding: "4px 8px",
        borderRadius: "20px",
        border: `1px solid ${colors.ic_green_300}`,
        background: colors.ic_green_100,
        whiteSpace: "nowrap",
        color: colors.ic_green_500,
    },

};

export default styles;